import { extendTailwindMerge, type ClassNameValue } from "tailwind-merge"

export const tailwindMergeConfig = {
  extend: {
    theme: {
      text: [
        "display",
        "title-lg",
        "title-md",
        "title-sm",
        "body-lg",
        "body-lg-strong",
        "body",
        "body-strong",
        "body-sm",
        "caption",
        "field",
        "field-strong",
        "label",
        "label-lg",
      ],
      color: [
        "cobalt-50",
        "cobalt-100",
        "cobalt-200",
        "cobalt-300",
        "cobalt-400",
        "cobalt-500",
        "gray-1000",
        "v2-foreground-default",
        "v2-foreground-default-disabled",
        "v2-foreground-inverse",
        "v2-foreground-inverse-disabled",
        "v2-foreground-active",
        "v2-foreground-primary",
        "v2-foreground-primary-strong",
        "v2-foreground-primary-stronger",
        "v2-foreground-primary-disabled",
        "v2-foreground-danger",
        "v2-foreground-danger-disabled",
        "v2-background-canvas",
        "v2-background-elevation-raised",
        "v2-background-elevation-modal",
        "v2-background-elevation-overlay",
        "v2-background-scrim",
        "v2-background-surface",
        "v2-background-surface-inverse",
        "v2-background-surface-strong",
        "v2-background-surface-stronger",
        "v2-background-surface-disabled",
        "v2-background-surface-inset",
        "v2-background-primary",
        "v2-background-primary-strong",
        "v2-background-primary-stronger",
        "v2-background-primary-disabled",
        "v2-background-primary-weak",
        "v2-background-danger",
        "v2-background-danger-strong",
        "v2-background-danger-disabled",
        "v2-background-success",
        "v2-background-accent",
        "v2-background-active",
        "v2-background-active-hover",
        "v2-background-surface-tonal",
        "v2-background-surface-tonal-strong",
        "v2-background-surface-tonal-stronger",
        "v2-background-danger-tonal",
        "v2-background-danger-tonal-strong",
        "v2-background-danger-tonal-stronger",
        "v2-foreground-danger-tonal",
        "v2-foreground-danger-tonal-strong",
        "v2-foreground-danger-tonal-stronger",
        "v2-background-alert-tonal",
        "v2-background-alert-tonal-strong",
        "v2-background-alert-tonal-stronger",
        "v2-foreground-alert-tonal",
        "v2-foreground-alert-tonal-strong",
        "v2-foreground-alert-tonal-stronger",
        "v2-background-success-tonal",
        "v2-background-success-tonal-strong",
        "v2-background-success-tonal-stronger",
        "v2-foreground-success-tonal",
        "v2-foreground-success-tonal-strong",
        "v2-foreground-success-tonal-stronger",
        "v2-background-information-tonal",
        "v2-background-information-tonal-strong",
        "v2-background-information-tonal-stronger",
        "v2-foreground-information-tonal",
        "v2-foreground-information-tonal-strong",
        "v2-foreground-information-tonal-stronger",
        "v2-background-ai-tonal",
        "v2-background-ai-tonal-strong",
        "v2-background-ai-tonal-stronger",
        "v2-foreground-ai-tonal",
        "v2-foreground-ai-tonal-strong",
        "v2-foreground-ai-tonal-stronger",
        "v2-foreground-default-weak",
        "v2-foreground-default-weaker",
        "v2-foreground-alert",
        "v2-foreground-success",
        "v2-foreground-information",
        "v2-foreground-ai",
        "v2-background-danger-weak",
        "v2-background-alert-weak",
        "v2-background-success-weak",
        "v2-background-information-weak",
        "v2-background-ai-weak",
        "v2-border-alert",
        "v2-border-success",
        "v2-border-information",
        "v2-border-ai",
        "v2-border-default",
        "v2-border-default-disabled",
        "v2-border-strong",
        "v2-border-stronger",
        "v2-border-active",
        "v2-border-danger",
        "v2-border-focus",
        "v2-border-swatch-ring",
        "v2-background-tag-red",
        "v2-background-tag-pink",
        "v2-background-tag-purple",
        "v2-background-tag-blue",
        "v2-background-tag-cyan",
        "v2-background-tag-green",
        "v2-background-tag-yellow",
        "v2-background-tag-gray",
        "v2-border-tag-red",
        "v2-border-tag-pink",
        "v2-border-tag-purple",
        "v2-border-tag-blue",
        "v2-border-tag-cyan",
        "v2-border-tag-green",
        "v2-border-tag-yellow",
        "v2-border-tag-gray",
      ],
      shadow: [
        "shadow-input",
        "shadow-control",
        "shadow-surface",
        "v2-button",
        "v2-input",
        "v2-raised",
        "v2-modal",
        "v2-overlay",
      ],
      animate: ["animate-skeleton-pulse", "animate-dooey-spin"],
      spacing: ["page-gutter"],
      radius: ["mark", "control", "surface", "overlay"],
    },
    classGroups: {
      "text-color": [
        "color-default",
        "color-subtle",
        "color-inverse",
        "color-warning",
        "color-button-default",
        "color-button-white-default",
        "color-brand-default",
        "color-icon-inverse",
        "color-icon-warning",
        "color-icon-white-default",
        "color-icon-white-disabled",
      ],
      "bg-color": [
        "bg-accent-blue",
        "bg-accent-gray",
        "bg-accent-bold-red",
        "bg-accent-bold-sky",
        "bg-accent-bold-blue",
        "bg-input-hovered",
        "bg-neutral-alternate",
        "bg-neutral-hovered",
        "bg-neutral-pressed",
        "bg-neutral-bold-default",
        "bg-primary-default",
        "bg-primary-disabled",
        "bg-danger-default",
        "bg-warning-default",
        "bg-success-default",
        "bg-information-default",
        "bg-brand-default",
        "bg-elevation-surface-default",
        "bg-elevation-surface-accent-default",
        "bg-icon-white-default",
        "bg-icon-white-disabled",
      ],
      "border-color": [],
      "divide-color": [],
      stroke: [],
    },
  },
}

const twMerge = extendTailwindMerge(tailwindMergeConfig)

export function classNames(...classes: ClassNameValue[]): string {
  return twMerge(classes)
}
